import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "login", //登录界面
      component: () => import("@/components/common/login"),
    },
    {
      path: "/addStudent", //添加学生
      component: () => import("@/components/teacher/addStudent"),
    },
    {
      path: "/index", //教师主页
      component: () => import("@/components/admin/index"),
      beforeEnter: function (to, from, next) {
        let role = window.$cookies.get("role");
        if (role === "2") {
          console.log("---------------");
          next({ path: "/" });
          return false;
        }
        next();
      },
      children: [
        {
          path: "/", //首页默认路由
          component: () => import("@/components/common/hello"),
        },
        {
          path: "/grade", //学生成绩
          component: () => import("@/components/charts/grade"),
        },
        {
          path: "/selectExamToPart", //学生分数段
          component: () => import("@/components/teacher/selectExamToPart"),
        },
        {
          path: "/scorePart",
          component: () => import("@/components/charts/scorePart"),
        },
        {
          path: "/allStudentsGrade", //所有学生成绩统计
          component: () => import("@/components/teacher/allStudentsGrade"),
        },
        {
          path: "/examDescription", //考试管理功能描述
          component: () => import("@/components/teacher/examDescription"),
        },
        {
          path: "/selectExam", //查询所有考试
          component: () => import("@/components/teacher/selectExam"),
        },
        {
          path: "/addExam", //添加考试
          component: () => import("@/components/teacher/addExam"),
        },
        {
          path: "/answerDescription", //题库管理功能介绍
          component: () => import("@/components/teacher/answerDescription"),
        },
        {
          path: "/selectAnswer", //查询所有题库
          component: () => import("@/components/teacher/selectAnswer"),
        },
        {
          path: "/addAnswer", //增加题库主界面
          component: () => import("@/components/teacher/addAnswer"),
        },
        {
          path: "/addAnswerChildren", //点击试卷跳转到添加题库页面
          component: () => import("@/components/teacher/addAnswerChildren"),
        },
        {
          path: "/studentManage", //学生管理界面
          component: () => import("@/components/teacher/studentManage"),
        },
        {
          path: "/addStudent", //添加学生
          component: () => import("@/components/teacher/addStudent"),
        },
        {
          path: "/teacherManage",
          component: () => import("@/components/admin/tacherManage"),
        },
        {
          path: "/addTeacher",
          component: () => import("@/components/admin/addTeacher"),
        },
      ],
    },
    {
      path: "/student",
      component: () => import("@/components/student/index"),
      children: [
        { path: "/", component: () => import("@/components/student/examMsg") },
        {
          path: "/startExam",
          component: () => import("@/components/student/startExam"),
        },
        {
          path: "/manager",
          component: () => import("@/components/student/manager"),
        },
        {
          path: "/examMsg",
          component: () => import("@/components/student/examMsg"),
        },
        {
          path: "/message",
          component: () => import("@/components/student/message"),
        },
        {
          path: "/information",
          component: () => import("@/components/student/information"),
        },
        {
          name: "studentScore",
          path: "/studentScore",
          component: () => import("@/components/student/answerScore"),
        },
        {
          path: "/scoreTable",
          component: () => import("@/components/student/scoreTable"),
        },
        {
          path: "/historyScore",
          component: () => import("@/components/student/historyScore"),
        },
      ],
    },
    {
      path: "/answer",
      component: () => import("@/components/student/answer"),
      // beforeEach: function (to, from, next) {
      //   console.log(to, from);
      //   // if (role === "2") {
      //   //   console.log("---------------");
      //   //   next({ path: "/" });
      //   //   return false;
      //   // }
      //   // next();
      // },
    },
  ],
});
router.beforeEach((to, from, next) => {
  let studentName = document.cookie.indexOf("cname") !== -1;
  let studentId = document.cookie.indexOf("cid") !== -1;
  if ((!studentName || !studentId) && to.path !== "/") {
    next({ path: "/" });
    return false;
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js